<h2>Chip Component</h2>

<div class="chips-grid">
	<div class="chip-column">
		<span class="label">Small (36px)</span>
		<app-chip label="Angular" [removable]="true" size="small" />
		<app-ui-code-block [code]="generateCode({component: 'chip', label: 'Angular', removable: true, size: 'small'})" />
	</div>

	<div class="chip-column">
		<span class="label">Large (40px)</span>
		<app-chip label="TypeScript" [removable]="true" size="large" />
		<app-ui-code-block [code]="generateCode({component: 'chip', label: 'TypeScript', removable: true, size: 'large'})" />
	</div>
</div>

<h2>Chips Input Component</h2>

<div class="chips-input-grid">
	<div class="chips-input-column">
		<span class="label">Chips input básico</span>
		<app-chips-input
			[formControl]="chipsControl"
			placeholder="Añade una etiqueta y presiona Enter"
		/>
		<app-ui-code-block [code]="generateCode({component: 'chips-input', formControl: 'chipsControl', placeholder: 'Añade una etiqueta y presiona Enter'})" />
	</div>

	<div class="chips-input-column">
		<span class="label">Chips input con label</span>
		<app-chips-input
			[formControl]="chipsControl"
			placeholder="Añade tecnologías"
			label="Tecnologías"
		/>
		<app-ui-code-block [code]="generateCode({component: 'chips-input', formControl: 'chipsControl', placeholder: 'Añade tecnologías', label: 'Tecnologías'})" />
	</div>

	<div class="chips-input-column">
		<span class="label">Chips input con error</span>
		<app-chips-input
			[formControl]="errorChipsControl"
			placeholder="Añade etiquetas"
			label="Etiquetas"
			[error]="true"
			errorMessage="Este campo es obligatorio"
		/>
		<app-ui-code-block [code]="generateCode({component: 'chips-input', formControl: 'errorChipsControl', placeholder: 'Añade etiquetas', label: 'Etiquetas', error: true, errorMessage: 'Este campo es obligatorio'})" />
	</div>
</div>
